import { render, staticRenderFns } from "./userjk.vue?vue&type=template&id=2c8fed3e"
import script from "./userjk.vue?vue&type=script&lang=js"
export * from "./userjk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports